// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Sentry = require("../reason/Sentry.bs.js");
var Scalars = require("../scalars/Scalars.bs.js");
var ButtonsV5 = require("../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Link = require("next/link").default;
var Icon__Jsx3 = require("../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var AuthSession = require("../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var RcSwipeout = require("rc-swipeout").default;
var AvatarSrcUrl = require("../utils/AvatarSrcUrl.bs.js");
var Avatar__Jsx3 = require("../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
var Theme__Color = require("../reason/common/Theme/Theme__Color.bs.js");
var AgentProfilePhoto = require("../v5/common/Agent/AgentProfilePhoto.bs.js");
var RelativeDateLabel = require("../reason/common/RelativeDateLabel.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ReactErrorBoundary = require("react-error-boundary");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationWidgetTexts = require("../modules/Notification/components/NotificationWidgetTexts.bs.js");
var UnselectedUnionMemberError = require("../v5/common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var AlertsDropdownItem_alert_graphql = require("../__generated__/AlertsDropdownItem_alert_graphql.bs.js");
var Conversation__ParticipantProfilePhoto = require("../v5/conversation/Conversation__ParticipantProfilePhoto.bs.js");

var item = "flex flex-row gap-2 p-4 group";

var userPic = "flex flex-col justify-start items-center w-8";

var content = "flex-1";

var action = "";

var close = "pl-2 pt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300";

var Styles = {
  item: item,
  userPic: userPic,
  content: content,
  action: action,
  close: close
};

var convertFragment = AlertsDropdownItem_alert_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AlertsDropdownItem_alert_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AlertsDropdownItem_alert_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AlertsDropdownItem_alert_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AlertsDropdownItem_alert_graphql.node, convertFragment, fRef);
}

var Fragment_alertStatus_decode = AlertsDropdownItem_alert_graphql.Utils.alertStatus_decode;

var Fragment_alertStatus_fromString = AlertsDropdownItem_alert_graphql.Utils.alertStatus_fromString;

var Fragment_buyerNeedMatchingType_decode = AlertsDropdownItem_alert_graphql.Utils.buyerNeedMatchingType_decode;

var Fragment_buyerNeedMatchingType_fromString = AlertsDropdownItem_alert_graphql.Utils.buyerNeedMatchingType_fromString;

var Fragment = {
  alertStatus_decode: Fragment_alertStatus_decode,
  alertStatus_fromString: Fragment_alertStatus_fromString,
  buyerNeedMatchingType_decode: Fragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: Fragment_buyerNeedMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AlertsDropdownItem$DismissAlert(props) {
  var onDismiss = props.onDismiss;
  return JsxRuntime.jsx("a", {
              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                    icon: "Cancel"
                  }),
              className: "text-zinc-500 no-underline hover:text-zinc-700",
              href: "#",
              onClick: (function (e) {
                  e.preventDefault();
                  onDismiss();
                })
            });
}

var DismissAlert = {
  make: AlertsDropdownItem$DismissAlert
};

function AlertsDropdownItem$WithoutErrorBoundary(props) {
  var onDismiss = props.onDismiss;
  var alert = use(props.alert);
  var currentAgentId = AuthSession.useCurrentUserId();
  var s = alert.byType;
  var tmp;
  switch (s.__typename) {
    case "AgentMatchLogAlert" :
        var agentMatchLog = s.agentMatchLog;
        if (agentMatchLog !== undefined) {
          var match = agentMatchLog.byType;
          var tmp$1;
          var exit = 0;
          switch (match.__typename) {
            case "ForSalePropertyAgentMatchLogV5" :
                var match$1 = match.source.agentV2;
                switch (match$1.__typename) {
                  case "VisibleForSalePropertyAgent" :
                      tmp$1 = JsxRuntime.jsx(AgentProfilePhoto.make, {
                            profilePhoto: match$1.agent.fragmentRefs,
                            className: "size-[24px]"
                          });
                      break;
                  case "AnonymousForSalePropertyAgent" :
                  case "__unselected" :
                      exit = 1;
                      break;
                  
                }
                break;
            case "__unselected" :
                exit = 1;
                break;
            default:
              tmp$1 = JsxRuntime.jsx(AgentProfilePhoto.make, {
                    profilePhoto: match.source.agent.fragmentRefs,
                    className: "size-[24px]"
                  });
          }
          if (exit === 1) {
            tmp$1 = JsxRuntime.jsx(Avatar__Jsx3.make, {
                  src: AvatarSrcUrl.place_holder,
                  name: "Agent chose to hide their name",
                  size: "micro"
                });
          }
          var s$1 = agentMatchLog.byType;
          var tmp$2;
          switch (s$1.__typename) {
            case "BuyerNeedAgentMatchLogV5" :
                tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.BuyerNeedMatchText.make, {
                      aml: s$1.fragmentRefs,
                      withLinks: true
                    });
                break;
            case "ForSalePropertyAgentMatchLogV5" :
                tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.PropertyMatchText.make, {
                      aml: s$1.fragmentRefs,
                      withLinks: true
                    });
                break;
            case "RentalNeedAgentMatchLogV5" :
                tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.RentalNeedMatchText.make, {
                      aml: s$1.fragmentRefs,
                      withLinks: true,
                      mode: "Alerts"
                    });
                break;
            case "RentalPropertyAgentMatchLogV5" :
                tmp$2 = JsxRuntime.jsx(NotificationWidgetTexts.RentalPropertyMatchText.make, {
                      aml: s$1.fragmentRefs,
                      withLinks: true
                    });
                break;
            case "__unselected" :
                tmp$2 = UnselectedUnionMemberError.raise(s$1._0);
                break;
            
          }
          tmp = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: tmp$1,
                        className: userPic
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          tmp$2,
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(RelativeDateLabel.make, {
                                      date: Scalars.DateTime.toUTC(alert.timestamp)
                                    })
                              })
                        ],
                        className: content
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Link, {
                              href: "/match_log/" + agentMatchLog.databaseId,
                              children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                        onClick: (function (param) {
                                            onDismiss();
                                          }),
                                        size: "small",
                                        children: "View Match"
                                      }))
                            }),
                        className: action
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(AlertsDropdownItem$DismissAlert, {
                              onDismiss: onDismiss
                            }),
                        className: close
                      })
                ],
                className: item
              });
        } else {
          tmp = null;
        }
        break;
    case "ConversationMessageAlert" :
        var match$2 = s.conversation;
        var match$3 = match$2.conversationContext;
        if (match$3.__typename === "AvailableConversationContext") {
          var from = s.message.from;
          var edges = match$2.messages.edges;
          var id = match$2.id;
          var context = match$3.context;
          var avatar = JsxRuntime.jsx(Conversation__ParticipantProfilePhoto.make, {
                participant: from.fragmentRefs,
                size: "micro"
              });
          var msgText;
          if (edges.length !== 1) {
            msgText = " sent you a direct message about ";
          } else {
            var match$4 = edges[0];
            if (match$4 !== undefined) {
              var match$5 = match$4.node.from;
              msgText = match$5.__typename === "Agent" && match$5.id === currentAgentId ? " replied to your direct message about " : " sent you a direct message about ";
            } else {
              msgText = " sent you a direct message about ";
            }
          }
          var match$6 = from.byType;
          var tmp$3;
          tmp$3 = match$6.__typename === "Agent" ? JsxRuntime.jsx(Link, {
                  href: "/agents/" + match$6.id,
                  children: Caml_option.some(avatar)
                }) : avatar;
          var match$7 = from.byType;
          var tmp$4;
          tmp$4 = match$7.__typename === "Agent" ? JsxRuntime.jsx(Link, {
                  href: "/agents/" + id,
                  children: Caml_option.some(match$7.displayName)
                }) : "A TAN agent";
          var tmp$5;
          switch (context.__typename) {
            case "BuyerNeedV5" :
                var priceRange = context.priceRange;
                var client = context.client;
                var tmp$6;
                var exit$1 = 0;
                if (client.ok === true) {
                  var match$8 = client.value;
                  if (match$8 !== undefined) {
                    tmp$6 = JsxRuntime.jsx(Link, {
                          href: "/my_clients/" + match$8.id,
                          children: Caml_option.some(match$8.displayName)
                        });
                  } else {
                    exit$1 = 1;
                  }
                } else {
                  exit$1 = 1;
                }
                if (exit$1 === 1) {
                  tmp$6 = JsxRuntime.jsx(Link, {
                        href: "/client_needs/" + id,
                        children: Caml_option.some((
                              context.matchingType === "BROADCAST" ? "their buyer need" : "their quiet buyer need"
                            ) + " (" + priceRange.minPrice.formatted + " - " + priceRange.maxPrice.formatted + "/month)")
                      });
                }
                tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        msgText,
                        tmp$6
                      ]
                    });
                break;
            case "ForSalePropertyV5" :
                var propertyLocation = context.propertyLocation;
                var client$1 = context.propertyClient;
                var displayString;
                switch (propertyLocation.__typename) {
                  case "PropertyLocationWithHiddenAddress" :
                      displayString = "their property in " + propertyLocation.locationDisplay;
                      break;
                  case "PropertyLocationWithVisibleAddress" :
                      var address = propertyLocation.address;
                      displayString = address !== undefined ? [
                            address,
                            propertyLocation.locationDisplay
                          ].join(" ") : "their property in " + propertyLocation.locationDisplay;
                      break;
                  case "__unselected" :
                      displayString = UnselectedUnionMemberError.raise(propertyLocation._0);
                      break;
                  
                }
                var tmp$7;
                var exit$2 = 0;
                if (client$1.ok === true) {
                  var match$9 = client$1.value;
                  if (match$9 !== undefined) {
                    tmp$7 = JsxRuntime.jsx(Link, {
                          href: "/my_clients/" + match$9.id,
                          children: Caml_option.some(displayString)
                        });
                  } else {
                    exit$2 = 1;
                  }
                } else {
                  exit$2 = 1;
                }
                if (exit$2 === 1) {
                  tmp$7 = JsxRuntime.jsx(Link, {
                        href: "/properties/" + id,
                        children: Caml_option.some(displayString)
                      });
                }
                tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        msgText,
                        tmp$7
                      ]
                    });
                break;
            case "MessageBroadcast" :
                tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        " replied to ",
                        JsxRuntime.jsx(Link, {
                              href: "/messages/" + context.id,
                              children: Caml_option.some(context.subject)
                            })
                      ]
                    });
                break;
            case "RentalNeedV5" :
                var priceRange$1 = context.priceRange;
                var client$2 = context.client;
                var tmp$8;
                var exit$3 = 0;
                if (client$2.ok === true) {
                  var match$10 = client$2.value;
                  if (match$10 !== undefined) {
                    tmp$8 = JsxRuntime.jsx(Link, {
                          href: "/my_clients/" + match$10.id,
                          children: Caml_option.some(match$10.displayName)
                        });
                  } else {
                    exit$3 = 1;
                  }
                } else {
                  exit$3 = 1;
                }
                if (exit$3 === 1) {
                  tmp$8 = JsxRuntime.jsx(Link, {
                        href: "/client_needs/" + id,
                        children: Caml_option.some("their rental need (" + priceRange$1.minPrice.formatted + " - " + priceRange$1.maxPrice.formatted + "/month)")
                      });
                }
                tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        msgText,
                        tmp$8
                      ]
                    });
                break;
            case "RentalPropertyV5" :
                var propertyLocation$1 = context.propertyLocation;
                var client$3 = context.propertyClient;
                var displayString$1;
                switch (propertyLocation$1.__typename) {
                  case "PropertyLocationWithHiddenAddress" :
                      displayString$1 = "their rental property in " + propertyLocation$1.locationDisplay;
                      break;
                  case "PropertyLocationWithVisibleAddress" :
                      var address$1 = propertyLocation$1.address;
                      displayString$1 = address$1 !== undefined ? [
                            address$1,
                            propertyLocation$1.locationDisplay
                          ].join(" ") : "their rental property in " + propertyLocation$1.locationDisplay;
                      break;
                  case "__unselected" :
                      displayString$1 = UnselectedUnionMemberError.raise(propertyLocation$1._0);
                      break;
                  
                }
                var tmp$9;
                var exit$4 = 0;
                if (client$3.ok === true) {
                  var match$11 = client$3.value;
                  if (match$11 !== undefined) {
                    tmp$9 = JsxRuntime.jsx(Link, {
                          href: "/my_clients/" + match$11.id,
                          children: Caml_option.some(displayString$1)
                        });
                  } else {
                    exit$4 = 1;
                  }
                } else {
                  exit$4 = 1;
                }
                if (exit$4 === 1) {
                  tmp$9 = JsxRuntime.jsx(Link, {
                        href: "/properties/" + id,
                        children: Caml_option.some(displayString$1)
                      });
                }
                tmp$5 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        msgText,
                        tmp$9
                      ]
                    });
                break;
            case "__unselected" :
                tmp$5 = UnselectedUnionMemberError.raise(context._0);
                break;
            
          }
          tmp = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: tmp$3,
                        className: userPic
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          tmp$4,
                          tmp$5,
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(RelativeDateLabel.make, {
                                      date: Scalars.DateTime.toUTC(alert.timestamp)
                                    })
                              })
                        ],
                        className: content
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Link, {
                              href: "/conversations/" + id,
                              children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                        onClick: (function (param) {
                                            onDismiss();
                                          }),
                                        size: "small",
                                        children: "View message"
                                      }))
                            }),
                        className: action
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(AlertsDropdownItem$DismissAlert, {
                              onDismiss: onDismiss
                            }),
                        className: close
                      })
                ],
                className: item
              });
        } else {
          tmp = null;
        }
        break;
    case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(s._0);
        break;
    
  }
  return JsxRuntime.jsx(RcSwipeout, {
              right: [{
                  text: "Dismiss",
                  style: {
                    backgroundColor: Theme__Color.toString(Theme__Color.crimson),
                    color: Theme__Color.toString(Theme__Color.white)
                  },
                  onPress: onDismiss
                }],
              children: tmp
            });
}

var WithoutErrorBoundary = {
  make: AlertsDropdownItem$WithoutErrorBoundary
};

function AlertsDropdownItem(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: (function (_error) {
                  return null;
                }),
              children: JsxRuntime.jsx(AlertsDropdownItem$WithoutErrorBoundary, {
                    alert: props.alert,
                    onDismiss: props.onDismiss
                  }),
              onError: (function (error) {
                  Sentry.captureException(error, "AlertsDropdownItem.res", undefined, undefined, undefined);
                })
            });
}

var make = AlertsDropdownItem;

exports.Styles = Styles;
exports.Fragment = Fragment;
exports.DismissAlert = DismissAlert;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Sentry Not a pure module */
